export const CARD_LIST: { cardCode: string; cardName: string }[] = [
  { cardCode: 'BCC', cardName: 'BC카드' },
  { cardCode: 'KBC', cardName: 'KB국민카드' },
  { cardCode: 'HNC', cardName: '하나카드' },
  { cardCode: 'SSC', cardName: '삼성카드' },
  { cardCode: 'SHN', cardName: '신한카드' },
  { cardCode: 'WRI', cardName: '우리카드' },
  { cardCode: 'HDC', cardName: '현대카드' },
  { cardCode: 'LTC', cardName: '롯데카드' },
  { cardCode: '007', cardName: '수협은행카드' },
  { cardCode: 'NHC', cardName: 'NH농협카드' },
  { cardCode: '035', cardName: '제주은행카드' },
  { cardCode: '034', cardName: '광주은행카드' },
  { cardCode: '037', cardName: '전북은행카드' },
  { cardCode: '027', cardName: '씨티카드' },
  { cardCode: '218', cardName: 'KB증권카드' },
  { cardCode: '050', cardName: '저축은행카드' },
  { cardCode: '071', cardName: '우체국카드' },
  { cardCode: '048', cardName: '신협카드' },
  { cardCode: '002', cardName: '산업은행카드' },
  { cardCode: '090', cardName: '카카오뱅크카드' },
  { cardCode: '089', cardName: '케이뱅크카드' },
  { cardCode: '247', cardName: '새마을금고카드' }
];

export const CARD_LOGO: Record<string, string> = {
  BCC: 'logo_bccard.svg',
  KBC: 'logo_kb.svg',
  HNC: 'logo_hana.svg',
  SSC: 'logo_samsungcard.svg',
  SHN: 'logo_shinhan.svg',
  WRI: 'logo_woori.svg',
  HDC: 'logo_hyundaicard.svg',
  LTC: 'logo_lottecard.svg',
  '007': 'logo_suhyup.svg',
  NHC: 'logo_nh.svg',
  '035': 'logo_shinhan.svg',
  '034': 'logo_jb.svg',
  '037': 'logo_jb.svg',
  '027': 'logo_citi.svg',
  '218': 'logo_kb.svg',
  '050': 'logo_sb.svg',
  '071': 'logo_koreapost.svg',
  '048': 'logo_shinhyup.svg',
  '002': 'logo_kdb.svg',
  '090': 'logo_kakaobank.svg',
  '089': 'logo_kbank.svg',
  '247': 'logo_mg-saemaeulgeumgo.svg'
};

export const getCardNameByCode = (cardCode: string): string => {
  const card = CARD_LIST.find((card) => card.cardCode === cardCode);
  return card ? card.cardName : '';
};
